import { createContext, useContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';
import type { FriendlyError } from '@/lib/errors';
import type { Profile } from '@/types/profile';

export type AuthState = {
  user: User | null;
  session: Session | null;
  profile: Profile | null;
  isAuthLoading: boolean;
  isProfileLoading: boolean;
};

export type AuthContextType = AuthState & {
  signInWithEmail: (email: string) => Promise<{ error: FriendlyError | null }>;
  verifyOtp: (
    email: string,
    token: string
  ) => Promise<{ error: FriendlyError | null }>;
  signInWithGoogle: () => Promise<void>;
  signInWithApple: () => Promise<void>;
  signOut: () => Promise<void>;
  refreshProfile: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined)
    throw new Error('useAuth must be used within an AuthProvider');
  return context;
}
